import ResultType from "../../enums/ResultType.js";
import ResultsSlice from "../../valueObjects/ResultsSlice.js";

/**
 * Checks whether results of ResultsSlice contains any pitch result
 * @param {ResultsSlice} slice 
 * @returns bool
 */
const resultsSliceWithPitch = function(slice) {
    return slice instanceof ResultsSlice
        && slice.getSmallestSlice().some(
            r => r.resultType && r.resultType.indexOf(ResultType.Pitch.key) > -1
        )
    ;
};

export default resultsSliceWithPitch;